import axios from "axios";
import { getAccessToken } from "Helpers/session";
import { apiURL } from "Helpers/url"

export const createSessionService = async() => {
  const tokenURL = apiURL('/report/otp_session/create')
  const accessToken = getAccessToken();
  try {
    const tokenResponse = await axios({
      method: "POST",
      url: tokenURL,
      data: {},
      headers: { Authorization: `Bearer ${accessToken}` },
    })

    return tokenResponse.data.one_time_token
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);
    return { error: { message: err.message } };
  }
}